import { useTranslation } from 'react-i18next'

export const GoToChatOrResults = () => {
	const { t } = useTranslation('intakeForm')
	return (
		<div>
			<div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
				<div className="mx-auto max-w-2xl text-center">
					<h2 className="text-xl font-bold tracking-tight text-gray-900 sm:text-4xl">
						{t('testCompletion.title')}
					</h2>
					<p className="mx-auto mt-6 max-w-xl text-lg leading-8 text-gray-600">
						{t('testCompletion.subtitle')}
					</p>
				</div>
			</div>
		</div>
	)
}
